
import { WorldCountry } from '../types';
import { australiaExpanded3 } from './australiaExpansion3';

// Expansión Fase 9 - Australia con 150+ ciudades
export const oceaniaExpansion3: WorldCountry[] = [
  australiaExpanded3
];
